import { render, staticRenderFns } from "./AlertScanSuccess.vue?vue&type=template&id=5143e0d6&scoped=true&"
import script from "./AlertScanSuccess.vue?vue&type=script&lang=ts&"
export * from "./AlertScanSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./AlertScanSuccess.vue?vue&type=style&index=0&id=5143e0d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5143e0d6",
  null
  
)

export default component.exports